var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDeleteInCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F46790",
  clipPath: "url(#ic-delete-in-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 .875A6.13 6.13 0 0 1 13.125 7 6.13 6.13 0 0 1 7 13.125 6.13 6.13 0 0 1 .875 7 6.13 6.13 0 0 1 7 .875M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.543 6.998c0 .268-.128.49-.396.49H4.859c-.28 0-.408-.222-.408-.49 0-.269.128-.49.408-.49h4.288c.268 0 .396.21.396.49"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-delete-in-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgIcDeleteInCircle;